module.exports = __webpack_public_path__ + "img/nunito-sans-v6-latin-800.67bf6e80.svg";